// ============================================================================
// REPOSITORY: LegalBIRepository — Acesso Firestore para Legal Business Intelligence
// ARQUIVO: src/services/LegalBIRepository.js
// ============================================================================

import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export function subscribeFinancialLedger(appId = DEFAULT_APP_ID, onData, onError) {
  const col = collection(db, ...FS.financialLedger(appId));
  const q = query(col, orderBy('createdAt', 'desc'));
  return onSnapshot(q, onData, onError);
}

export function subscribeTimesheetEntries(appId = DEFAULT_APP_ID, onData, onError) {
  const col = collection(db, ...FS.timesheetEntries(appId));
  const q = query(col, orderBy('date', 'desc'));
  return onSnapshot(q, onData, onError);
}
